module.exports = __webpack_public_path__ + "media/01 lunar calender.9a728f6e.mp3";